import { useMutation, useQueryClient } from '@tanstack/react-query'
import { invoiceKeys } from '@/entities/invoice'
import { apiRequest } from '@/shared/api'

// Переходы статуса счёта — плоская инвалидация всего namespace счетов (счета
// живут и в контуре проекта, и в контуре компании; конкретный список неизвестен
// хуку), плюс точечно карточка счёта.
function useInvoiceTransition(action: 'pay' | 'claim-payment' | 'decline-claim') {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (invoiceId: string) =>
      apiRequest({ method: 'POST', url: `/invoices/${invoiceId}/${action}` }),
    onSuccess: (_data, invoiceId) => {
      void qc.invalidateQueries({ queryKey: invoiceKeys.all })
      void qc.invalidateQueries({ queryKey: invoiceKeys.detail(invoiceId) })
    },
  })
}

// Сотрудник: issued|payment_claimed → paid.
export function usePayInvoice() {
  return useInvoiceTransition('pay')
}

// Заказчик: issued → payment_claimed («Оплатил»).
export function useClaimInvoicePayment() {
  return useInvoiceTransition('claim-payment')
}

// Сотрудник: payment_claimed → issued (отклонить заявленную оплату).
export function useDeclineInvoiceClaim() {
  return useInvoiceTransition('decline-claim')
}
